/**
 * Studio UI for the open-link viewer gate (who a group link asks) and the "Who viewed" table.
 * Buyer pages follow the server instead: public-status says `viewerGate` and `engagementTracking`.
 */
export const isCatalogueViewerGateEnabled = (): boolean =>
  process.env.REACT_APP_CATALOGUE_VIEWER_GATE === "true";
